import { render, staticRenderFns } from "./BilateralAgreementCountries.vue?vue&type=template&id=32d44fe8&scoped=true"
import script from "./BilateralAgreementCountries.vue?vue&type=script&lang=js"
export * from "./BilateralAgreementCountries.vue?vue&type=script&lang=js"
import style0 from "./BilateralAgreementCountries.vue?vue&type=style&index=0&id=32d44fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d44fe8",
  null
  
)

export default component.exports